var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "23px",
    viewBox: "0 0 19 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mask Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Apps-/-Fire-&-BOX",
    transform: "translate(-497.000000, -718.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M507.67234,723.417504 C507.359042,723.51507 506.899202,723.597232 506.2625,723.653717 C506.318085,720.74213 507.773404,718.693235 510.709308,718 C511.179255,720.136191 509.390425,722.832105 507.67234,723.417504 L507.67234,723.417504 Z M513.801862,727.150703 C514.125266,726.668006 514.640691,726.128823 515.348138,725.522885 C514.221277,724.105604 512.917553,723.248046 511.047872,723.248046 C509.259042,723.248046 507.753192,724.18263 506.651596,724.18263 C505.716755,724.18263 504.028989,723.355883 502.381649,723.355883 C498.864628,723.355883 497,726.852869 497,730.493637 C497,734.540076 500.016755,741 503.073936,741 C504.276596,741 505.357979,740.075687 506.788032,740.075687 C508.268617,740.075687 509.456117,740.958919 510.845745,740.958919 C513.170213,740.958919 515.322872,736.979236 516,734.812235 C513.635106,734.077919 511.735106,730.180397 513.801862,727.150703 Z",
    id: "Mask-Copy"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.c13c91fdf887f0beef74a0747601bda1.svg";
export { ForwardRef as ReactComponent };